Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _styles2 = require("../FullScreenDialog/styles");
var _CommitmentModalType = require("./CommitmentModalType");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var modalType = _ref.modalType;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS,
    fontBold = _STYLES$useStyles.fontBold,
    boxShadows = _STYLES$useStyles.boxShadows,
    grid = _STYLES$useStyles.grid,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var _useStylesFullScreenD = (0, _styles2.useStyles)(),
    FullScreenDialogStyles = _useStylesFullScreenD.styles;
  var modalButtons = {
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
    maxWidth: grid.maxInputWidth,
    marginLeft: 'auto',
    marginRight: 'auto'
  };
  if ([_CommitmentModalType.CommitmentModalType.pending, _CommitmentModalType.CommitmentModalType.existing, _CommitmentModalType.CommitmentModalType.complete, _CommitmentModalType.CommitmentModalType.successfulLimit].includes(modalType)) {
    modalButtons.width = '100%';
  }
  var modalButtonsLeft = {};
  var modalButtonsRight = {};
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l])) {
    modalButtons.flexDirection = 'column';
    modalButtonsRight.marginTop = spacing.l;
  }
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l])) {
    modalButtons.width = '100%';
    modalButtonsLeft.width = '50%';
    modalButtonsLeft.paddingRight = spacing.normal;
    modalButtonsLeft.alignItems = 'flex-end';
    modalButtonsRight.width = '50%';
    modalButtonsRight.paddingLeft = spacing.normal;
    modalButtonsRight.alignItems = 'flex-start';
  }
  var modalContentHeading = {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: spacing.m,
    fontSize: fontSize.l,
    lineHeight: lineHeight.l
  };
  var recommendedStepsItemContainer = {
    width: '100%',
    paddingLeft: spacing.xs,
    paddingRight: spacing.xs
  };
  if (bp.lt(32.75)) {
    recommendedStepsItemContainer.paddingLeft = spacing.l;
    recommendedStepsItemContainer.paddingRight = spacing.l;
  }
  var recommendedStepsItem = Object.assign({}, boxShadows.none, {
    borderColor: COLORS.iron,
    borderStyle: 'solid',
    borderWidth: (0, _styles.getREM)(0.125)
  });
  var recommendedStepsCarousel = {
    marginLeft: _reactNative.Platform.OS === 'web' ? "calc(-1 * (".concat(FullScreenDialogStyles.background.paddingLeft, " + ").concat(spacing.normal, " + ").concat(spacing.normal, "))") : -1 * (FullScreenDialogStyles.background.paddingLeft + spacing.normal),
    marginRight: _reactNative.Platform.OS === 'web' ? "calc(-1 * (".concat(FullScreenDialogStyles.background.paddingRight, " + ").concat(spacing.normal, " + ").concat(spacing.normal, "))") : -1 * (FullScreenDialogStyles.background.paddingRight + spacing.normal),
    marginBottom: spacing.xl
  };
  var benefits = {
    width: '100%',
    marginBottom: spacing.xl
  };
  var modalCardStyle = {
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(grid.maxTextWidth, " + (").concat(spacing.normal, " * 2))") : grid.maxTextWidth + spacing.normal * 2,
    paddingLeft: spacing.normal,
    paddingRight: spacing.normal,
    paddingBottom: spacing.xl
  };
  if ([_CommitmentModalType.CommitmentModalType.pending, _CommitmentModalType.CommitmentModalType.existing, _CommitmentModalType.CommitmentModalType.complete, _CommitmentModalType.CommitmentModalType.organizationShare].includes(modalType)) {
    modalCardStyle.maxWidth = _reactNative.Platform.OS === 'web' ? "calc(".concat(grid.maxCardWidth, " + (").concat(spacing.normal, " * 2))") : grid.maxCardWidth + spacing.normal * 2;
    modalCardStyle.paddingLeft = spacing.l;
    modalCardStyle.paddingRight = spacing.l;
  }
  var title = {
    marginBottom: 0,
    textAlign: 'center',
    fontSize: fontSize.xl,
    lineHeight: lineHeight.xl
  };
  var text = {
    color: COLORS.aubergine,
    fontSize: fontSize.l,
    lineHeight: lineHeight.l
  };
  if ([_CommitmentModalType.CommitmentModalType.pending, _CommitmentModalType.CommitmentModalType.existing, _CommitmentModalType.CommitmentModalType.complete, _CommitmentModalType.CommitmentModalType.organizationShare].includes(modalType)) {
    text = Object.assign({}, text, fontBold);
  }
  var textContainer = {
    marginTop: spacing.xl,
    marginBottom: spacing.xl,
    textAlign: 'center',
    maxWidth: grid.maxTextBlockWidth
  };
  if ([_CommitmentModalType.CommitmentModalType.pending, _CommitmentModalType.CommitmentModalType.existing, _CommitmentModalType.CommitmentModalType.complete, _CommitmentModalType.CommitmentModalType.organizationShare].includes(modalType)) {
    textContainer.marginTop = spacing.m;
    textContainer.marginBottom = spacing.m;
  }
  var imageContainer = {
    marginBottom: spacing.normal,
    width: '100%',
    height: 120
  };
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    imageContainer.height = 140;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    imageContainer.height = 180;
    imageContainer.marginBottom = spacing.xl;
  }
  var shareContainer = {
    marginBottom: spacing.xl
  };
  var stepTile = {
    width: '100%',
    maxWidth: '100%',
    marginBottom: spacing.l
  };
  var styles = _reactNative.StyleSheet.create({
    modalButtons: modalButtons,
    modalButtonsLeft: modalButtonsLeft,
    modalButtonsRight: modalButtonsRight,
    modalContentHeading: modalContentHeading,
    recommendedStepsItemContainer: recommendedStepsItemContainer,
    recommendedStepsItem: recommendedStepsItem,
    recommendedStepsCarousel: recommendedStepsCarousel,
    benefits: benefits,
    modalCardStyle: modalCardStyle,
    title: title,
    textContainer: textContainer,
    text: text,
    image: {
      width: '100%',
      height: '100%'
    },
    imageContainer: imageContainer,
    shareContainer: shareContainer,
    stepTile: stepTile
  });
  return {
    styles: styles
  };
};